import { render, staticRenderFns } from "./personalCertification.vue?vue&type=template&id=45216c9c&scoped=true&"
import script from "./personalCertification.vue?vue&type=script&lang=js&"
export * from "./personalCertification.vue?vue&type=script&lang=js&"
import style0 from "./personalCertification.vue?vue&type=style&index=0&id=45216c9c&prod&scoped=true&lang=css&"
import style1 from "./personalCertification.vue?vue&type=style&index=1&id=45216c9c&prod&scoped=true&lang=scss&"
import style2 from "./personalCertification.vue?vue&type=style&index=2&id=45216c9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45216c9c",
  null
  
)

export default component.exports